import React from 'react';
import clsx from 'clsx';
import { makeStyles} from '@material-ui/core/styles';
import {Drawer, Divider, Menu, MenuItem, IconButton} from '@material-ui/core';
import { AppLogo, RaymanUser } from 'components/core';
import {NavButton, NavList} from 'components/nav';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import PersonIcon from '@material-ui/icons/Person';
import HelpIcon from '@material-ui/icons/Help';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Singletons from 'controllers/Singletons';
import { Assistant, Ballot, ContactSupport, HeadsetMic, PlaylistAdd, QuestionAnswer } from '@material-ui/icons';
import UserInfoDialog from 'components/users/UserInfoDialog';
import NestedMenuItem from 'material-ui-nested-menu-item';


const inner = (theme) => {
    const drawerWidth = 240;
    return {
    root: {
      display: 'flex',
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: 'hidden',
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(9) + 1,
      },
    },
    logo: {
      padding: 10,
      margin: 10,
      marginLeft: 36,
      maxHeight: 60,
      objectFit: 'contain',
      objectPosition: 'left',
      maxWidth: '100%'
    },
    footer:
    {
      bottom: 0,
      position: 'absolute',
      width: '100%',
      padding: 20,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center'
    },
    footerUser:
    {
      flexGrow: 1
    },
    footerButton:
    {
      flexGrow: 0,
      flexBasis: 24,
      padding: '0 8px',
    },
    footerMenu:
    {
      minWidth: 150
    },
    footerVersion:
    {
      fontSize: '8px',
      position: 'absolute',
      left: 5,
      bottom: 5
    },
    title: {
      textAlign: "center",
      display: "inline-block",
      width: "100%",
      fontWeight: 500,
      borderBottom: `1px solid ${theme.palette.text.primary}`,
      padding: 5
    }
  };
};

const useStyles = makeStyles(inner, {name: "RaymanNav"});


function Nav(props)
{
    const classes = useStyles();
    //   const theme = useTheme();
    const [navOpen, setNavOpen] = React.useState(true);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const isMenuOpen = Boolean(anchorEl);
    const [userProfileOpen, setUserProfileOpen] = React.useState(false);
    
    const setUserState = (state) => {
        Singletons.NotificationsSocket.Send("users.state.update", "module", {state: state});
        setAnchorEl(null);
    }


    const openMenu = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const closeMenu = () => {
      setAnchorEl(null);
    };

    const logout = () => {
      sessionStorage.setItem("userToken",undefined);
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    }

    const adminNav = [      
       ...Singletons.userProfiles.admin ? [<NavButton key="users" icon={<PersonIcon />} expanded={navOpen} label="Usuarios" to="/users"/>] : [],
       ...Singletons.userProfiles.admin ? [<NavButton key="tags" icon={<LocalOfferIcon />} expanded={navOpen} label="Etiquetas" to="/tags"/>] : [],
       ...Singletons.userProfiles.admin ? [<NavButton key="items" icon={<Assistant />} expanded={navOpen} label="Items" to="/items"/>] : [],
       ...Singletons.userProfiles.admin ? [<NavButton key="templates" icon={<PlaylistAdd />} expanded={navOpen} label="Plantillas" to="/templates"/>] : [],
       ...Singletons.userProfiles.admin ? [null] : [],
       ...Singletons.userProfiles.admin ? [null] : [],
      <NavButton key="help" icon={<HelpIcon />} expanded={navOpen} label="Ayuda" target="_blank" href="https://cableo.es/help"/>
    ];

    return <Drawer
    variant="permanent"
    className={clsx(classes.drawer, {
      [classes.drawerOpen]: navOpen,
      [classes.drawerClose]: !navOpen,
    })}
    classes={{
      paper: clsx({
        [classes.drawerOpen]: navOpen,
        [classes.drawerClose]: !navOpen,
      }),
    }}
  >

    {/* <div className={classes.toolbar}>
        {open ? 
            <IconButton onClick={handleDrawerClose}>
                {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
        :
            <IconButton onClick={handleDrawerOpen}>
                {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
        }
    </div> */}
    {/* <Divider /> */}
    <AppLogo className={classes.logo}/>
    <NavList>
      <NavButton icon={<HeadsetMic />} expanded={navOpen} label="Asistencia" to="/operations"/>
      <NavButton icon={<AssignmentTurnedInIcon />} expanded={navOpen} label="Tareas" to="/tasks"/>
      <NavButton icon={<AssignmentIcon />} expanded={navOpen} label="Procedimientos" to="/procedures"/>
      <NavButton icon={<QuestionAnswer />} expanded={navOpen} label="Canales" to="/channels"/>
    </NavList>
    <Divider />
    <NavList>
      {adminNav}
    </NavList>
    <div className={classes.footer}>
      <UserInfoDialog open={userProfileOpen} onClose={()=>setUserProfileOpen(false)} userID={Singletons.currentUser.userID}/>
      <RaymanUser userID={Singletons.currentUser.userID} className={classes.footerUser} forcebadge/>
      <IconButton className={classes.footerButton} onClick={openMenu}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="userMenu"
        anchorEl={anchorEl}
        keepMounted
        open={isMenuOpen}
        onClose={closeMenu}
        PaperProps={{className: classes.footerMenu}}
      >
        <NestedMenuItem label="Cambiar Estado" parentMenuOpen={isMenuOpen}>
          <MenuItem onClick={()=>setUserState("available")}>Disponible</MenuItem>
          <MenuItem onClick={()=>setUserState("unavailable")}>Ocupado</MenuItem>
          <MenuItem onClick={()=>setUserState("away")}>Ausente</MenuItem>
        </NestedMenuItem>
        <MenuItem onClick={()=>setUserProfileOpen(true)}>Ver perfil</MenuItem>
        <MenuItem onClick={logout} >
          Cerrar Sesión
        </MenuItem>
      </Menu>
      {/* <div className={classes.footerVersion}>{"v "+global.appVersion}</div> */}
    </div>
  </Drawer>
}

export default Nav;